import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import U2000ActionBtn from "../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaArrowLeft, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { NS } from "../../U3134";

export interface U3134TecAgeReportToolbarProps {
  onExportExcel: () => void;
  onExportPdfHierarchy: () => void;
  onExportPdfWipList: () => void;
  exportDisabled: boolean;
  isExportingExcel: boolean;
  isExportingPdf: boolean;
}

const U3134TecAgeReportToolbar: React.FC<U3134TecAgeReportToolbarProps> = ({
  onExportExcel,
  onExportPdfHierarchy,
  onExportPdfWipList,
  exportDisabled,
  isExportingExcel,
  isExportingPdf,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const pdfExportDisabled = exportDisabled || isExportingPdf;

  const actions = [
    {
      key: "back",
      label: t("btnTecAgeBackToList", { ns: NS }),
      hasRole: true,
      handleClick: () => navigate("/U3134"),
      icon: FaArrowLeft,
      Component: U2000ActionBtn,
    },
    {
      key: "exportExcel",
      label: t("btnExportTecAgeExcel", { ns: NS }),
      hasRole: true,
      handleClick: onExportExcel,
      disabled: exportDisabled || isExportingExcel,
      icon: FaFileExcel,
      Component: U2000ActionBtn,
    },
    {
      key: "exportPdfHierarchy",
      label: t("btnTecAgeExportPdfHierarchy", { ns: NS }),
      hasRole: true,
      handleClick: onExportPdfHierarchy,
      disabled: pdfExportDisabled,
      icon: FaFilePdf,
      Component: U2000ActionBtn,
    },
    {
      key: "exportPdfWipList",
      label: t("btnTecAgeExportPdfWipList", { ns: NS }),
      hasRole: true,
      handleClick: onExportPdfWipList,
      disabled: pdfExportDisabled,
      icon: FaFilePdf,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};

export default U3134TecAgeReportToolbar;
